import { ApiEndpoints, APIMethods } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import * as yup from "yup";
import { EducationalMaterialTranslation } from "./fetchEducationalMaterialFiles";

export const fetchEducationalMaterialLink = async (
  id: number,
): Promise<EducationalMaterialLinkResponse> => {
  const response = await fetchData(
    `${ApiEndpoints.EducationalMaterialsLink}/${id}`,
    APIMethods.GET,
  );

  return await educationalMaterialLinkSchema.validate(response);
};

export const translationSchema = yup.object({
  lang: yup.string().required(),
  name: yup.string().nullable().defined(),
  description: yup.string().nullable().defined(),
});

export interface ImageType {
  id: number;
  url: string;
}

export const imageSchema = yup.object({
  id: yup.number().required(),
  url: yup.string().required(),
});

export interface CategoryType {
  id: number | null;
}

export interface EducationalMaterialData {
  id: number;
  name: string | null;
  description: string | null;
  translations: EducationalMaterialTranslation[];
  reviewed: boolean;
  image: ImageType | null;
  url: string | null;
  category: CategoryType | null;
}

export const categorySchema = yup.object({
  id: yup.number().nullable().defined(),
});

export const educationalMaterialDataSchema = yup.object({
  id: yup.number().required(),
  name: yup.string().nullable().defined(),
  description: yup.string().nullable().defined(),
  translations: yup.array().of(translationSchema).defined(),
  reviewed: yup.boolean().required(),
  image: imageSchema.nullable(),
  url: yup.string().nullable().defined(),
  category: categorySchema.nullable(),
});

export interface EducationalMaterialLinkResponse {
  data: EducationalMaterialData;
}

export const educationalMaterialLinkSchema = yup.object({
  data: educationalMaterialDataSchema.required(),
});
